<template>

<div class="mt-2">

    <div v-if='$store.state.isOwner && $parent.projectPhase.user_id == user.id'>
        <div class='alert alert-info'>
            Вие сте се самоназначили като ръководител на проекта.
        </div>
    </div>

    <div v-else>

        <div v-if='isReady' class="row">
            <div class="col-12">
                <div class="selected-item auction-item list-item shadow">
                    <div class="list-info">
                        
                        <div class="list-header pt-3 pl-4 pr-4 pb-2">
                            <div class="row">
                                <div class="col-md-6 text-center text-md-left mb-2">
                                    <h5 class="mb-0 mt-1">
                                        <a :href='"/contractors/" + auction.uid' target="_blank">
                                            {{ auction.name }} {{ auction.last_name }}

                                            <span v-if='auction.brand'>
                                                ( {{ auction.brand }} )
                                            </span>
                                        </a>                                        
                                    </h5>
                                    <div class="d-flex justify-content-start">
                                        <user-rating :rating='auction.rating'></user-rating>   
                                    </div>                  
                                </div>

                                <div class="col-md-6 text-center text-md-right">
                                    <div class="auction-price">{{ auction.cost }} лв.</div>
                                    <div class="auction-time">
                                        <span class="capt">Срок на изпълнение:</span>
                                        <span class="cont">{{ auction.time }} дни</span>
                                    </div>
                                </div>
                            </div>
                        </div>                        

                        <div class="list-body p-4">
                            <div class="row">
                                <div class="col-12">

                                    <div v-if='delivery && !finished && delivery.status == 0'>
                                        <phase-timer :end='delivery.end_date' :msg='timerMessage'></phase-timer>
                                    </div>

                                    <div v-if='delivery && finished' class="alert alert-info">
                                        Срокът за изпълнението е приключил.
                                    </div>

                                    <div v-if='!delivery' class="alert alert-info">
                                        Работата по изпълнението ще бъде стартирана от администратор на Видеа.
                                    </div>

                                    <div v-if='delivery && delivery.finished == 0'>
                                        <div class="alert alert-info">
                                            Когато изпълнителя е готов с работата, ще получите нотификация и ще можете да прегледате извършената работа.
                                        </div>
                                    </div>
                                    <div v-if='delivery && delivery.finished == 1'>
                                        <div class="alert alert-info" v-if='delivery.status == 0'>
                                            Работата по този етап е маркирана като завършена от страна на изпълнителя и следва да бъде одобрена от администратор
                                        </div>
                                        <div class="alert alert-info" v-if='delivery.status == 1'>
                                            Работата по този етап е маркирана като завършена от страна на изпълнителя и одобрена от администратор.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <loading-div></loading-div>
        
        <div class='row mt-5'>

            <div class="col-12">
                <h3 class="fieldset-title text-left mb-4">Файлове качени от изпълнителя </h3>
            </div>

            <div class="col-12 d-md-flex justify-content-center">
                <ul class="list-inline d-flex align-items-center files-view">
                    <li @click="grid = false" :class="[ 'list-inline-item', { active : !grid }]">
                        <span class="icon icon-list"></span>
                    </li>

                    <li @click="grid = true" :class="[ 'list-inline-item', { active : grid }]">
                        <span class="icon icon-grid"></span>
                    </li>
                </ul>

                <div v-if='isReady && !files.length' class="alert alert-info w-100">
                    Все още нямате качени файлове. 
                </div>

                <div v-if='isReady && files.length' id="files-holder" :class="{ 'grid-view' : grid, 'list-view' : !grid  }">

                    <div>

                        <file-grid :files='files' 
                                   :conf='fileConfig'
                                   :info='"Качен от изпълнител"'></file-grid>

                    </div>     

                </div>

            </div>
        </div>

        <div class="row mt-5">
            
            <div class="col-12">
                <h3 class="fieldset-title text-left mb-0">Комуникация с изпълнителя</h3>
                
                <project-messages :conf='msgConfig'></project-messages>
            </div>
        </div>
        
    </div>

</div>

</template>

<script>
    export default {

        mounted() {
            this.getData();
        },

        created() {
           
        },

        data() {

            return {
                timerMessage : 'Времето е изтекло',

                isReady     : false,
                auction     : false,
                delivery    : false,
                grid        : false,

                files : [],

                finished    : false,

                fileConfig : {
                    info        : "Качен от изпълнител",
                    lightBoxId  : 'ufph',
                    download    : true,
                    removeUrl   : 'phs:rmf'
                },

                msgConfig : {
                    getUrl      : 'pmsg:gtpm',
                    getParams : {
                        pp : this.$parent.projectPhase.id
                    },
                    publishParams : {
                        project_phase_id : this.$parent.projectPhase.id,
                        project_id       : this.$parent.project.id
                    },
                    owner_id : this.$parent.project.user_id
                },
            }
        },

        methods : {

            getData() {
                
                var me = this;

                me.ajax.call('phs:gaw', { pp : this.$parent.projectPhase.id }, (r) => {

                    if( r.status == 'success' ) {

                        me.auction  = r.data.a;
                        me.delivery = r.data.d;
                        me.files    = r.data.f; 
                    
                        me.initParams();
                    
                    }

                    me.isReady = true;
                })

            },

            initParams() {
                if( !this.delivery ) {
                    return;
                }

                var now = new Date();
                var endDate = new Date( this.delivery.end_date.split('-').join('/') );

                var diff = Math.ceil( ( endDate.getTime() - now.getTime() ) / 1000 );

                if( diff <= 0 ) {
                    this.finished = true;
                }

            },

        },

        components : {
            
        }

    }
</script>
